import httpAuth from '@/services/httpAuth'

// import { serialize2 } from '@/services/object'

export async function loadDashboard (dados) {
  return httpAuth.post('/admin/dashboard', dados)
}
